import { createRouteRef } from "@backstage/frontend-plugin-api";

/**
 * Route ref for the full-page Constellation graph.
 * Used by ConstellationGraphCard to link to the page dynamically,
 * rather than hardcoding the path.
 */
export const rootRouteRef = createRouteRef();
